import React from 'react';
import './styles.css';





export const AulasExploradoresTituloEncabezado = () => {


  return (
    <>


        <div className='AulasExploradoresTituloEncabezado-Principal-Container'>

                <div className='AulasExploradoresTituloEncabezado-subContainer'>

                        <div className='AulasExploradoresTituloEncabezado-titulo'/>

                        <div className='AulasExploradoresTituloEncabezado-imagen'/>
                        
                </div>
        </div>

        
    </>
  )
}
